import { render, staticRenderFns } from "./CashReward.vue?vue&type=template&id=4f5b122d&scoped=true&"
import script from "./CashReward.vue?vue&type=script&lang=js&"
export * from "./CashReward.vue?vue&type=script&lang=js&"
import style0 from "./CashReward.vue?vue&type=style&index=0&id=4f5b122d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b122d",
  null
  
)

export default component.exports